import { DOMHelper } from "./dom-helper";
import { MarketingClientConstants } from "../constants/marketing-client-constants";

export enum DeviceType {
    MOBILE = "mobile",
    DESKTOP = "desktop"
}

export class DeviceInformationHelper {
    static getDeviceType() {
        return DOMHelper.querySelector(MarketingClientConstants.rootElement)?.getAttribute("data-device");
    }

    static getOS() {
        return DOMHelper.querySelector(MarketingClientConstants.rootElement)?.getAttribute("data-os");
    }

    static getXX() {
        return DOMHelper.querySelector(MarketingClientConstants.rootElement)?.getAttribute("data-xx");
    }
}
